import { setTerms } from './helpers';

export const setFloorTypes = setTerms('floor_types');
